<template>
  <div class="fs-24 fs-md-20 fw-medium text-center pt-60">
    Выберите свой вариант:
  </div>

  <div class="sleep-menu grid-row d-flex_wrap mt-md-12">
    <BundleTypeList />
  </div>

  <section class="pt-60 js-sleep-group">
    <div class="sleep-tabs" id="product1">
      <div class="fs-24 fs-md-20 fw-medium text-center">
        Выберите первый товар:
      </div>

      <div class="mt-24" id="pool1">
        <BundlePool number="1" />
      </div>
    </div>
  </section>

  <section class="pt-60 js-sleep-group">
    <div class="sleep-tabs" id="product1">
      <div class="fs-24 fs-md-20 fw-medium text-center">
        Выберите второй товар:
      </div>

      <div class="mt-24" id="pool2">
        <BundlePool number="2" />
      </div>
    </div>
  </section>

  <section class="pt-60 js-sleep-group">
    <div class="sleep-tabs" id="product1">
      <div class="fs-24 fs-md-20 fw-medium text-center">
        Выберите третий товар:
      </div>

      <div class="mt-24" id="pool3">
        <BundlePool number="3" />
      </div>
    </div>
  </section>

  <section class="pt-60">
    <div class="sleep-result">
      <div class="sleep-result__row d-flex d-flex_wrap d-flex_center">
        <SelectedProduct number="1" />
        <SelectedProduct number="2" />
        <SelectedProduct number="3" />

        <div
          v-if="isSelected"
          class="sleep-result__item sleep-result__item_full text-center"
        >
          <div class="text-primary fw-medium fs-24 fs-md-20">
            Ваша выгода:
            <span class="d-md-block nowrap"
              >{{ bundleProfit.toLocaleString("ru-RU") }} ₽</span
            >
          </div>
          <div class="mt-8">
            Цена за комплект:
            {{ bundleSummaryDiscounted.toLocaleString("ru-RU") }} ₽
            <span class="price-old"
              >{{ bundleSummary.toLocaleString("ru-RU") }} ₽</span
            >
          </div>
          <div class="sleep-result__button mt-32 mx-auto d-md-none">
            <button
              class="button button_primary button_md fw-bold text-uppercase w-100"
              :disabled="!isSelected"
              @click="this.store.addToCart()"
            >
              ОФОРМИТЬ ЗАКАЗ
            </button>
          </div>
        </div>
      </div>

      <div class="sleep-result__button mt-20 mx-auto d-none d-md-block">
        <button
          class="button button_primary button_md fw-bold text-uppercase w-100"
          :disabled="!isSelected"
          @click="this.store.addToCart()"
        >
          ОФОРМИТЬ ЗАКАЗ
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import BundleTypeList from "./BundleTypeList.vue";
import BundlePool from "./BundlePool.vue";
import { useBundleStore } from "@/sleep_bundle/stores/bundle";
import SelectedProduct from "@/sleep_bundle/components/SelectedProduct.vue";

export default {
  name: "BundleBuilder",
  components: { SelectedProduct, BundleTypeList, BundlePool },
  setup() {
    const store = useBundleStore();

    return {
      store,
    };
  },
  created() {
    this.store.getBundleList();
  },
  computed: {
    isSelected() {
      let selectedProducts = Object.values(this.store.selected).filter(
        (product) => {
          return typeof product === "object" && Object.keys(product).length > 0;
        }
      );

      return selectedProducts.length === 3;
    },
    bundleSummary() {
      let sum = 0;
      Object.values(this.store.selected).forEach((item) => {
        if (typeof item.PRICE !== "undefined") {
          sum += Number(item.PRICE);
        }
      });

      return Number(sum);
    },
    bundleSummaryDiscounted() {
      return Number(this.bundleSummary - (this.bundleSummary * 25) / 100);
    },
    bundleProfit() {
      return Number(this.bundleSummary - this.bundleSummaryDiscounted);
    },
  },
};
</script>
